/**
 * Iter-59 — Help Center article renderer.
 *
 * Maps the article's `sections[]` array to primitive components.
 * Kept intentionally dumb — no data fetching, no state; the parent
 * page hands it a fully-resolved article dict.
 */
import React from "react";
import {
  HelpBullets, HelpCallout, HelpCode, HelpFAQ, HelpKV,
  HelpScreenshot, HelpSteps, HelpTable, Rich,
} from "./HelpPrimitives";

export function HelpArticleRenderer({ sections }) {
  return (
    <div data-testid="help-article-body">
      {sections.map((s, i) => (
        <SectionBlock key={i} section={s} />
      ))}
    </div>
  );
}

function SectionBlock({ section }) {
  switch (section.kind) {
    case "paragraph":
      return <p className="text-sm text-zinc-800 my-3 leading-relaxed"><Rich text={section.text} /></p>;
    case "heading":
      return (
        <h3 className="font-chivo font-black text-lg uppercase tracking-tight mt-6 mb-2 border-b border-black pb-1">
          {section.text}
        </h3>
      );
    case "steps":
      return <HelpSteps items={section.items} />;
    case "bullets":
      return <HelpBullets items={section.items} />;
    case "callout":
      return <HelpCallout variant={section.variant}>{section.text}</HelpCallout>;
    case "screenshot":
      return (
        <HelpScreenshot
          asset={section.asset}
          caption={section.caption}
          annotations={section.annotations}
          takenAt={section.taken_at}
          outdated={section.outdated}
        />
      );
    case "table":
      return <HelpTable headers={section.headers} rows={section.rows} />;
    case "kv":
      return <HelpKV pairs={section.pairs} />;
    case "code":
      return <HelpCode language={section.language} code={section.code} />;
    case "faq":
      return <HelpFAQ items={section.items} />;
    default:
      return null;
  }
}
